import { pushRetryableEvent } from "./utils";
import PullToRefreshJs from "./PullToRefreshJs.js";

export default PullToRefresh = {
    mounted() {
        const eventPusher = this;
        PullToRefreshJs.setPassiveMode(false);
        PullToRefreshJs.init({
            mainElement: "#infinite-scroll-body",
            triggerElement: "#infinite-scroll-body",
            shouldPullToRefresh: function () {
                return !this.mainElement.scrollTop;
            },
            onRefresh(done) {
                setTimeout(() => {
                    pushRetryableEvent(eventPusher, "load_new", { test: "test" });
                    done();
                }, 500);
            },
        });
    },
    beforeUpdate() {
        let scrollableContainer = document.getElementById("infinite-scroll-body");
        scrollableContainer.classList.remove("overflow-y-scroll");
    },
    updated() {
        let scrollableContainer = document.getElementById("infinite-scroll-body");
    },
};
